import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-bell-ringing-03',
  imports: [],
  templateUrl: './bell-ringing-03.html',
  styleUrl: './bell-ringing-03.scss',
})
export class BellRinging03 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
